import React from 'react';
import { cn } from '../../utils/cn';

interface TabProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isActive?: boolean;
  icon?: React.ReactNode;
  badge?: React.ReactNode;
}

export function Tab({
  className,
  isActive = false,
  icon,
  badge,
  children,
  ...props
}: TabProps) {
  return (
    <button
      className={cn(
        'relative flex flex-1 flex-col items-center justify-center gap-1.5 py-3 transition-colors',
        'focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2',
        isActive
          ? 'text-primary border-b-2 border-primary'
          : 'text-on-surface-variant hover:text-on-surface hover:bg-on-surface/5',
        className
      )}
      {...props}
    >
      {icon && <span className="text-lg">{icon}</span>}
      <span className="text-xs font-medium">{children}</span>
      {badge && (
        <span className="absolute -right-1 -top-1 flex h-4 w-4 items-center justify-center rounded-full bg-error text-[10px] font-bold text-on-error">
          {badge}
        </span>
      )}
    </button>
  );
}

export function TabBar({
  className,
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'flex h-16 w-full overflow-x-auto bg-surface border-t border-outline',
        'md:justify-center md:border-t md:border-outline',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}
